import request from '../utils/request'


export function index(params) {
  	return request({
  	  url: '/clinicImages',
  	  method: 'get',
        params
  	})
  }
  export function inventory(params) {
    return request({
      url: '/clinicImages/inventory',
      method: 'get',
      params
    })
  }
  
export function show(id) {
    return request({
      url: `/clinicImages/${id}`,
      method: 'get'
    })
  }

  export function storeImage(data) {
    return request({
      url: '/clinicImages',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/clinicImages/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/clinicImages/${id}`,
      method: 'delete',
    })
  }
